import { AcadNavTabs } from "@components";
import routes from "./StudentVerificationRoutes";

const StudentVerification = () => {
  return <AcadNavTabs routes={routes} />;
};

export default StudentVerification;
